<template>
    <vPerformancePersonSnapshotComponent :postList="postList" v-if="flag"></vPerformancePersonSnapshotComponent>
</template>
<script>
import vPerformancePersonSnapshotComponent from '../../listComponent/basicdata/performance/performancePersonSnapshotComponent.vue';
export default {
    name: 'performance_person',
    components: {
        vPerformancePersonSnapshotComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                config_rid: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>